(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ora-country-selector"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ora-country-selector')) {
    customElements.define('ora-country-selector', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.dialog = this.querySelector('dialog');
        this.form = this.querySelector('form');
        this.select = this.querySelector('[data-ora-country]');
        this.storageKey = 'ora.delivery-country.v1';
        this.pendingKey = 'ora.delivery-country.pending.v1';
        this.dismissKey = 'ora.delivery-country.dismissed.v1';
        const pending = this.readStorage('sessionStorage', this.pendingKey);
        if (pending) {
          if (pending === this.dataset.country) this.writeStorage('localStorage', this.storageKey, pending);
          this.removeStorage('sessionStorage', this.pendingKey);
        }
        this.querySelector('[data-ora-open]').addEventListener('click', () => this.open());
        this.querySelector('[data-ora-close]').addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('close', () => {
          document.documentElement.style.overflow = this.previousOverflow || '';
          this.writeStorage('sessionStorage', this.dismissKey, '1');
        });
        this.select.addEventListener('change', () => {
          this.querySelector('[data-ora-currency]').textContent = this.select.selectedOptions[0].dataset.currency;
        });
        this.form.addEventListener('submit', () => {
          this.writeStorage('sessionStorage', this.pendingKey, this.select.value);
        });
        const confirmed = this.readStorage('localStorage', this.storageKey);
        const dismissed = this.readStorage('sessionStorage', this.dismissKey);
        if (this.dataset.autoOpen === 'true' && this.dataset.designMode !== 'true' && !confirmed && !dismissed) {
          this.timer = window.setTimeout(() => this.open(), 650);
        }
      }
      disconnectedCallback() {
        window.clearTimeout(this.timer);
        if (this.dialog && this.dialog.open) this.dialog.close();
      }
      readStorage(storage, key) { try { return window[storage].getItem(key); } catch (_) { return null; } }
      writeStorage(storage, key, value) { try { window[storage].setItem(key, value); } catch (_) {} }
      removeStorage(storage, key) { try { window[storage].removeItem(key); } catch (_) {} }
      open() {
        if (this.dialog.open) return;
        this.previousOverflow = document.documentElement.style.overflow;
        this.dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ora-trade-form"] && !Shopify.designMode) return;
  try {
    
function initOraTradePreview() {
  document.querySelectorAll('[data-ora-trade-test]').forEach(root => {
    const button = root.querySelector('[data-trade-submit]');
    if (!button || button.dataset.ready) return;
    button.dataset.ready = 'true';
    button.disabled = false;
    button.addEventListener('click', () => {
      const form = root.querySelector('[data-trade-form]');
      if (!form.reportValidity()) return;
      const email = form.elements.email.value.trim();
      root.querySelector('[data-trade-email]').textContent = email;
      root.querySelector('[data-trade-account-email]').textContent = email;
      const result = root.querySelector('[data-trade-result]');
      result.hidden = false;
      result.focus();
      result.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });
}
initOraTradePreview();
document.addEventListener('shopify:section:load', initOraTradePreview);

  } catch(e) { console.error(e); }
})();
})();
